<template>
    <section v-if="json" class="page-careers">
        <div class="capper" data-aos="custom-fade-in">
            <div class="capper-padded">
                <div class="copy">
                    <div class="rte no-max-width">
                        <h1 v-if="json.title" v-html="json.title"></h1>
                        <div class="under-title" v-if="json.body" v-html="json.body"></div>
                    </div>

                    <p>&nbsp;</p>
                    <div class="expandables">
                        <div
                            v-for="(item, index) in json.positions"
                            :class="['expandable', (expandableSectionOpen === index) ? 'open' : 'closed']"
                            :key="`expandable${index}`"
                        >
                            <h3 @click="toggleSection(index)">
                                <span class="dot"></span>
                                <span class="title">{{item.title}}</span>
                                <span v-if="item.area" class="area">&nbsp;&mdash;&nbsp;{{item.area}}</span>
                            </h3>
                            <div ref="expandableContent" class="expanded" :data-index="index">
                                <div ref="expandableContentRte" class="rte no-max-width" v-html="item.body"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="json.bottomImage?.[0].url" class="capper" data-aos="custom-fade-in">
            <div class="fill-img">
                <img :src="json.bottomImage?.[0].url"/>
            </div>
        </div>
    </section>
</template>

<script>
import axios from 'axios'
import gsap, {Power3} from 'gsap'
import gh from '@/helpers/gh'

export default {
    name: "CareersPage",
    data () {
        return {
            window: window,
            json: null,
            expandableSectionOpen: null, // No section is open initially
            sectionHeights: [] // Store the calculated heights of the sections
        }
    },
    mounted () {
        let slug = this.$route.fullPath
        slug = gh.stripSlashesFrontAndBack(slug)
        axios.get((`${window.config.apiroot}${slug}/${window.config.craftApiPreviewToken}`))
            .then((res) => {
                this.json = res.data
                this.$nextTick(() => {
                    this.calculateHeights() // Calculate heights after the content is rendered
                    this.setInitialHeights() // Set the initial height for each section to 0
                    this.window.addEventListener('resize', this.calculateHeights) // Recalculate heights on window resize

                    // set initial
                    //this.expandableSectionOpen = 0
                    //this.openSection(0)
                })
            }).catch((e) => {
            console.error('Error', slug, e)
        })
    },
    beforeUnmount() {
        this.window.removeEventListener('resize', this.calculateHeights) // Clean up event listener
    },
    methods: {
        calculateHeights() {
            this.sectionHeights = this.$refs.expandableContentRte.map((section) => {
                return section.scrollHeight + 5
            })
            this.updateOpenSectionHeight()
        },
        updateOpenSectionHeight() {
            if (this.expandableSectionOpen !== null) {
                const openSectionIndex = this.expandableSectionOpen;
                const section = this.$refs.expandableContent[openSectionIndex];
                const updatedHeight = this.sectionHeights[openSectionIndex]; // Get the recalculated height

                // Update the height of the currently open section
                gsap.to(section, {
                    height: updatedHeight,
                    duration: 0,
                    ease: Power3.easeInOut
                });
            }
        },
        setInitialHeights() {
            // Set the initial height for each expandable section to 0
            this.$refs.expandableContent.forEach(section => {
                gsap.set(section, {height: 0}) // Ensure the height is initially 0 for each section
            })
        },
        toggleSection(index) {
            // Close the section if it's already open
            if (this.expandableSectionOpen === index) {
                this.closeSection(index)
                this.expandableSectionOpen = null
            } else {
                if (this.expandableSectionOpen !== null) {
                    this.closeSection(this.expandableSectionOpen) // Close previously opened section
                }
                this.expandableSectionOpen = index
                this.openSection(index)
            }
        },
        openSection(index) {
            const section = this.$refs.expandableContent[index]
            const contentHeight = this.sectionHeights[index] // Get the pre-calculated height for this section

            gsap.to(section,
                {height: contentHeight, duration: 0.5, ease: Power3.easeInOut} // Animate to the pre-calculated height
            )
        },
        closeSection(index) {
            const section = this.$refs.expandableContent[index]
            gsap.to(section,
                {height: 0, duration: 0.5, ease: Power3.easeInOut} // Animate to height of 0
            )
        }
    }
}
</script>